import { JETableRow, JETableRowCell } from 'components/Tables/grid/StyledComponents';
import { styled } from '@mui/material/styles';
import { MIN_WIDTH } from 'components/Tables/layout/JEVirtualLinesTable/constants';
import c from 'components/Tables/constatnt';

export const JEVirtualLinesRoot = styled('div', {
  label: 'JEVirtualLinesRoot',
})(() => ({
  position: 'relative',
  marginTop: 5,
  marginRight: 0,
  marginBottom: 30,
  marginLeft: 0,
  height: 'calc(100% - 80px)',
  minHeight: 310, // allows for scrolling in je-at-the-bottom split view
}));

export const JEVirtualLinesTableHeader = styled('div', {
  label: 'JEVirtualLinesTableHeader',
})(() => ({
  position: 'sticky',
  top: 0,
  width: '100%',
  height: 26,
  zIndex: 14,
}));

export const JEVirtualLinesTableBody = styled('div', {
  label: 'JEVirtualLinesTableBody',
})(() => ({
  position: 'relative',
}));

export const VirtualOuterElement = styled('div', {
  label: 'VirtualOuterElement',
})(() => ({
  overflow: 'auto',
  position: 'relative',
  width: '100%',
  paddingBottom: 2,

  '[data-scroll-box="open"] &': {
    overflow: 'hidden',
  },

  '&::-webkit-scrollbar': {
    appearance: 'none',
    '&:horizontal': {
      height: 7,
    },
    '&:vertical': {
      width: 7,
    },
  },
  '&::-webkit-scrollbar-thumb': {
    borderRadius: 4,
    backgroundColor: 'rgba(0,0,0,.5)',
    boxShadow: '0 0 1px rgba(255,255,255,.5)',
  },
}));

export const VirtualTableRow = styled(JETableRow, {
  label: 'VirtualTableRow',
})(({ theme }) => ({
  display: 'flex',

  '&.je-v-table-row-is-active': {
    backgroundColor: '#E2EAFF',

    '& .je-v-table-cell-remove': {
      opacity: 1,
    },
  },

  '&:hover': {
    backgroundColor: '#F9F5E8',

    '& .je-v-table-cell-remove': {
      opacity: 1,
    },
  },

  '& .je-v-table-cell-remove': {
    flex: '0 0 30px',
    width: 30,
    lineHeight: 0,
    opacity: 0,
  },

  '& .je-v-table-cell-remove-disabled': {
    opacity: 0,
    background: theme.palette.common.white,
  },
}));

export const VirtualTableCell = styled(JETableRowCell, { label: 'VirtualTableCell' })(({ theme }) => ({
  width: '100%',
  flexGrow: 1,
  borderBottom: '1px solid #DEE2E6',
  minWidth: MIN_WIDTH,

  '&:hover': {
    backgroundColor: '#F8F8F8',
  },

  '&::before': {
    content: '""',
    position: 'absolute',
    top: -1,
    left: -1,
    bottom: 2,
    borderRight: '1px solid #DEE2E6',
    zIndex: 0,
    '.rtl &': {
      left: 'auto',
      right: -1,
    },
    '.ltr &': {
      left: -1,
    },
  },

  '&:first-child:before': {
    display: 'none',
  },

  '&.je-v-table-cell-mandatory': {
    border: `1px solid ${theme.palette.error.main}`,
    '&:before': {
      display: 'none',
    },
  },

  '&.je-v-table-cell-active': {
    backgroundColor: '#E2EAFF',
    outline: `1px solid ${theme.palette.primary.light}`,
    outlineOffset: -1,
    zIndex: 10,
    '&:before, & + .je-v-table-cell:before': {
      display: 'none',
    },
    '[data-scroll-box="open"] &': {
      zIndex: 20,
    },
  },
}));

export const VirtualTableResize = styled('button', {
  label: 'VirtualTableResize',
})(() => ({
  height: c.ROW_HEIGHT,
  width: 8,
  position: 'absolute',
  cursor: 'col-resize',
  zIndex: 10,
  outline: 'none',
  border: 'none',
  background: 'transparent',
  right: -5,
  top: 0,
  '&:before': {
    content: '""',
    width: 2,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    position: 'absolute',
    background: 'transparent',
    margin: 'auto',
  },
}));
